import api from "!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../node_modules/css-loader/dist/cjs.js?url=false!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!./sidePanel.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};